var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec11Img4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9724 18.1993L17.0944 20.3268C17.1447 20.3772 17.2265 20.3766 17.276 20.3256L22.0277 15.4252M15.5258 31.5149H22.8688C22.9391 31.5149 22.9961 31.4578 22.9961 31.3875V27.3424C22.9961 27.2721 22.9391 27.215 22.8688 27.215H21.4744M15.5258 31.5149H13.993C13.9227 31.5149 13.8657 31.4578 13.8657 31.3875V27.3424C13.8657 27.2721 13.9227 27.215 13.993 27.215H14.9724M15.5258 31.5149C15.5258 36.2308 21.4744 36.0921 21.4744 31.5149M14.9724 27.215C14.9724 27.215 8.86054 22.4509 8.88545 18.1993C8.91664 12.8752 13.2597 8.5515 18.5692 8.62867C23.8024 8.70472 27.9942 12.9518 27.9764 18.1993C27.9616 22.5441 21.4744 27.215 21.4744 27.215M14.9724 27.215H21.4744M27.5613 27.215L30.8814 30.544M30.8814 18.1993H36M27.1462 9.46096L30.8814 5.99335M18.5692 5.99335V1M9.71542 9.46096L6.25692 5.99335M6.25692 18.1993H1M9.71542 27.215L6.25692 30.544",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec11Img4);
export default __webpack_public_path__ + "static/media/sec11img4.2cdd6c3561e1c345d51b618400b3e93c.svg";
export { ForwardRef as ReactComponent };